export default __webpack_public_path__ + "static/media/google-pay.5577d5a9.svg";